import HTMLReactParser from 'html-react-parser';
import type { DocumentItemProps } from './documentsListingResolver';

export type DocumentPages = {
    title?: string;
    summary?: string;
    type?: string;
    topic?: string[];
    category?: string[];
    fileType?: string;
    fileSize?: string;
    downloadUrl?: string;
    url?: string;
}

export const resolveDocumentItems = (items: DocumentPages[]): DocumentItemProps[] => {
    return items.map(item => {
        const {
            title,
            summary,
            type,
            topic,
            category,
            url,
            downloadUrl,
            fileType,
            fileSize,
        } = item as NonNullable<typeof item>;

        return {
            ...(url && { link: { href: url } }),
            title: title as string,
            ...(summary && { summary: HTMLReactParser(summary as string) }),
            type,
            topic,
            category,
            url,
            downloadUrl,
            fileType,
            fileSize,
        };
    });
};
